import { ExperiencePerformanceTypes, ExperienceTypes } from '@atlassian/ufo';

import type { ExperienceId, NavigationExperienceIdEnum } from './types';

// register the new experience key in http://go/perfportal

export const NavigationExperienceId: {
	[key in NavigationExperienceIdEnum]: ExperienceId;
} = {
	goalCreate: {
		experienceId: 'uc-goal-create',
		config: {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		},
	},
	teamCreate: {
		experienceId: 'uc-team-create',
		config: {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		},
	},
	projectCreate: {
		experienceId: 'uc-project-create',
		config: {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		},
	},
	universalCreateComponentLoad: {
		experienceId: 'uc-component-load',
		config: {
			type: ExperienceTypes.Load,
			performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
		},
	},
	universalCreatePrefetch: {
		experienceId: 'uc-prefetch',
		config: {
			type: ExperienceTypes.Load,
			performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
		},
	},
};
